define('../src/sublayouts/m21-tabs/m21-tabs',['jquery', 'breakpoint', 'lib/utils'], function($, breakpoint, utils) {

    'use strict';

    /**
     * This module only effects Tabs on desktop. Mobile view uses the toggle helper.
     */

    var Tabs = function($component) {

        this.$component = $component;

        return this;
    };

    Tabs.prototype.init = function() {
        var _this = this;

        // cache dom els
        this.$tabs = this.$component.find('[data-m21-tabs-tab="true"]');
        this.$tabsMenu = this.$component.find('[data-m21-tabs-menu="true"]');
        this.$content = this.$component.find('[data-m21-tabs-content="true"]');
        this.$selected = this.$component.data('selected-tab-id');
        this.selectedTabID = utils.getParameterByName('faq');
        // id param makes more sense but keep above for backward compatibility
        if (this.selectedTabID === '') this.selectedTabID = utils.getParameterByName('id');

        // props
        this.$tabs.each(function () {
            var tabTitle = $(this).text().trim();

           // _this.$component.find('#'+$(this).attr('aria-controls')+'[data-m21-tabs-content="true"]').not('.titled').prepend('<div class="m14-richtext mb12"><h4>'+tabTitle+'</h4></div>');
            _this.$component.find('#'+$(this).attr('aria-controls')+'[data-m21-tabs-content="true"]').addClass('titled');
        });

        this.activeTabsClass = 'm21-tabs__tab--active';
        this.activeContentClass = 'm21-tabs__content--active';

        this.$selectedTab = this.$tabs.eq(0);

        if (this.selectedTabID !== '') {

            this.$selectedTab = this.$component.find('#' + this.selectedTabID);
            if (this.$selectedTab[0] === undefined) this.$selectedTab = this.$tabs.eq(0);

        }

        this.respond();

        $(breakpoint).on('change', $.proxy(this.respond, this));
        $(window).on('resize',$.proxy(this.respond, this))

        //expand listener
        $('.m21-tabs__tab').on('click', function() {
            if ($(this).hasClass('icon-close')) {
                $(this).next('ul').addClass('ul--m21-active');
                $(this).removeClass('icon-close');
                $(this).addClass('icon-open');
            } else if ($(this).hasClass('icon-open')) {
                $(this).next('ul').removeClass('ul--m21-active');
                $(this).removeClass('icon-open');
                $(this).addClass('icon-close');
            } else {
                $('.m21-tabs__tab').next('ul').removeClass('ul--m21-active');
                $('.m21-tabs__tab').each(function() {
                    if ($(this).hasClass('icon-open')) {
                        $(this).removeClass('icon-open');
                        $(this).addClass('icon-close');
                    } else {}
                });
            }
        });

    };

    Tabs.prototype.respond = function() {

        this.setUpDesktopView();

        if (utils.breakpoint() === 's') {

            this.setUpMobileView();

        } else {

        }
    };

    Tabs.prototype.setUpDesktopView = function() {

        var self = this,
            _this = this;

        //this.$tabsMenu.show();
        if (this.$component.attr('m21isLink') != 'true') {
            this.$tabs.on('click', function(e) {

                e.preventDefault();
                self.displayTab($(this));

            });

            this.displayTab(this.$selectedTab);

            $('#' + _this.$selected).click();
        };

    };

    Tabs.prototype.setUpMobileView = function() {
        var _this = this;

        $('.m21-tabs--select-mobile').empty();
        $('.m21-tabs--container-mobile').empty();

        this.$component.find('.toggle-menu__item').each(function(i) {
            var html_cat = $(this).find('.m21-tabs__title').html(),
                html_con = $(this).find('.m21-tabs__content').html(),
                html_conID = $(this).find('.m21-tabs__content').attr('id').replace('panel', 'tab'),
                color = $(this).find('.moset').data('color');
                if(i==0){
                    $('.m21-tabs--select-mobile').closest('.form-field--select').addClass('color-' + color)
                }
            $('<option class="' + html_conID + '" data-color="'+ color +'" data-trigger-index="' + html_conID + '"' + '>' + html_cat + '</option>').appendTo($('.m21-tabs--select-mobile'));
        });

        this.$component.find('.m21-tabs__tab').each(function() {
            if ($(this).hasClass('m21-tabs__tab--active')) {
                $('option[data-trigger-index="' + $(this).attr('id').replace('panel', 'tab') + '"]').prop('selected', true)
            }
        });

        $('.m21-tabs--select-mobile').change(function() {
            var index_trigger = $(this).children(":selected").attr('data-trigger-index'),
                selectColor = $(this).children(":selected").attr('data-color'),
                selectClass = 'color-' + selectColor,
                thisWrapper = $(this).closest('.form-field--select');
                thisWrapper.removeClass (function (index, className) {
                    return (className.match (/(^|\s)color-\S+/g) || []).join(' ');
                });
                thisWrapper.addClass(selectClass)
            if (_this.$component.attr('m21isLink') != 'true') {
                _this.$tabsMenu.find('#' + index_trigger).click();
            } else {
                window.location.href = _this.$tabsMenu.find('#' + index_trigger).attr('href');
            }
        });
    };

    Tabs.prototype.displayTab = function($tab) {

        this.$tabs.removeClass(this.activeTabsClass).attr('aria-selected', false);

        $tab.addClass(this.activeTabsClass);
        $tab.attr('aria-selected', true);
        this.$content.removeClass(this.activeContentClass);
        this.$content.parent().removeClass('toggle-menu__itemactive');
        $('#' + $tab.attr('aria-controls')).addClass(this.activeContentClass);
        $('#' + $tab.attr('aria-controls')).parent().addClass('toggle-menu__itemactive');
        this.$selectedTab = $tab;


    };

    Tabs.prototype.fixPosition = function() {

        var self = this;

        if (utils.fixedHeader()) {

            $('body').animate({
                scrollTop: self.$component.offset().top - utils.headerBarHeight() - 60

            }, 100);
        }
    };

    Tabs.prototype.orientationchange = function() {

        this.reset();
        this.respond();
    };

    Tabs.prototype.reset = function() {

        this.$content.removeClass(this.activeContentClass);
        this.$content.parent().removeClass('toggle-menu__itemactive');
        this.$tabs.removeClass(this.activeTabsClass);
        this.$tabs.off('click');
        this.$component.find('[data-toggle-trigger]').off('click.scroll');
    };

    return Tabs;

});

